/**
 * 클립보드 복사 SSOT.
 *
 * 실패 경로가 많다 — Chrome은 문서에 포커스가 없으면 `NotAllowedError`를 던지고,
 * iOS Safari는 사용자 제스처 밖의 호출을 거부하며, 일부 인앱 브라우저는
 * `navigator.clipboard` 자체가 없어 프로퍼티 접근에서 터진다.
 * 그래서 동기 접근까지 try 안에 넣고, 실패하면 hidden textarea + execCommand로
 * 폴백한다.
 *
 * 반환값이 false면 복사되지 않은 것이다 — 호출부는 절대 성공 UI를 띄우면 안 된다.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fallthrough to execCommand
  }

  try {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}
